import { string, objectOf } from "prop-types";
import TimestampLabel from "../timestampLabel/TimestampLabel";

export const progressTimestampPropTypes = {
  progressText: string,
  timestampLabel: objectOf(TimestampLabel),
};
